import { useState, useEffect } from "react";
import { Loading } from "../Other/Loading";
import { toast } from "react-toastify";
import axiosInstance from "@/axios";
import axios from "axios";
import { useTranslation } from "react-i18next";
const LeadForm = () => {
  const [formData, setFormData] = useState(null);
    const { t } = useTranslation();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    job_title: "",
    number_of_learner: "",
    government_agency: false,
    country: "",
    needs_description: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
          const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
          console.log("API Response:44444444", response.data); // Log response to debug
          const events = JSON.parse(response.data);
          console.log("API Response:44444444", events.leadForm);
          setFormData(events.leadForm);  // turns string into array of objects
        }
        catch (error) {
          console.error("Error fetching reasons data:", error);
        }
    };
  
    fetchData();
  }, [t]);
  
  if (!formData) return <p><Loading /></p>;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = (e) => {
    setForm((prev) => ({ ...prev, government_agency: e.target.checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = [
    { name: "first_name", label: "First Name" },
    { name: "last_name", label: "Last Name" },
    { name: "email", label: "Email" },
    { name: "phone", label: "Phone" },
    { name: "job_title", label: "Job Title" },
    { name: "number_of_learner", label: "Expected number of learners" },
    { name: "country", label: "Country" },
    { name: "needs_description", label: "Needs Description" },
  ];

  const emptyFields = requiredFields.filter(({ name }) => !form[name]);

  if (emptyFields.length > 0) {
    emptyFields.forEach((field) => {
      toast.error(`${field.label} is required`);
    });
    return;
  }
    try {
      const response = await axiosInstance.post("/request/corporate-training", form);
      toast.success("Your request has been submitted!");
      // Clear form
      setForm({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        job_title: "",
        number_of_learner: "",
        government_agency: false,
        country: "",
        needs_description: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div id="lead-form" className="max-w-full mx-auto p-6 md:p-[48px] lg:flex lg:gap-12 bg-[#ffffff] ">
      {/* Left Section */}
      <div className="lg:w-1/2 space-y-6">
        <h2 className="text-5xl font-bold">{formData.heading}</h2>
        <p className="text-gray-600 text-xl">{formData.description}</p>
        <ul className="list-disc pl-5 text-gray-700">
          {formData.benefits.map((benefit, index) => (
            <li key={index}>{benefit}</li>
          ))}
        </ul>

        {/* Company Logos */}
        <h3 className="text-xl font-semibold">Top companies develop skills with yslearn</h3>
        <div className="grid grid-cols-3 gap-4 md:grid-cols-3 lg:grid-cols-3 items-center">
          {formData.companies.map((company, index) => (
            <img
              key={`${process.env.REACT_APP_COURSE_API_BASEURL}${index}`}
              src={`${process.env.REACT_APP_SMIK_API_BASEURL}${company.logo}`}
              alt={company.name}
              className="w-24 mx-auto"
            />

          ))}
        </div>

        {/* Testimonial */}
        <div className="mt-6">
          {/* Quote Section */}
          <blockquote className="border-l-4 border-blue-500 pl-4 text-gray-700 mt-2">
            “{formData?.testimonial?.quote}”
          </blockquote>

          {/* Flex Container for Logo & Author Details */}
          <div className="flex items-center space-x-4 mt-6">
            {/* Left Side: Equifax Logo */}
            {formData?.testimonial?.companylogo && (
              <img
                src={`${process.env.REACT_APP_SMIK_API_BASEURL}${formData.testimonial.companylogo}`}
                alt="Equifax Logo"
                className="w-24 h-auto"
              />
            )}

            {/* Right Side: Author Details */}
            <div className="flex-grow">
              <p className="font-bold">{formData?.testimonial?.author}</p>
              <p className="text-gray-500">
                {formData?.testimonial?.position} at {formData?.testimonial?.company}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <form onSubmit={handleSubmit} className="w-auto md:w-[500px] ml-auto bg-white shadow-md p-6 rounded-lg border border-2 h-fit">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input name="first_name" value={form.first_name} onChange={handleChange} type="text" placeholder="First Name" className="input rounded-sm" />
          <input name="last_name" value={form.last_name} onChange={handleChange} type="text" placeholder="Last Name" className="input" />
          <input name="email" value={form.email} onChange={handleChange} type="email" placeholder="Work Email Address" className="input" />
          <input name="phone" value={form.phone} onChange={handleChange} type="text" placeholder="Phone Number" className="input" />
          <input name="job_title" value={form.job_title} onChange={handleChange} type="text" placeholder="Job Title" className="input" />
          <input name="number_of_learner" value={form.number_of_learner} onChange={handleChange} type="number" placeholder="Expected number of learners" className="input" />
        </div>

        <div className="flex items-start mt-4 mb-4">
          <input
            type="checkbox"
            checked={form.government_agency}
            onChange={handleCheckbox}
            id="policy"
            className="!w-5 h-5 accent-blue-600 cursor-pointer mt-0.5 mr-2"
          />
          <label htmlFor="policy" className="text-sm text-gray-700 leading-snug">
            Do you work for a government or nonprofit agency?
          </label>
        </div>

        <input
          name="country"
          value={form.country}
          onChange={handleChange}
          type="text"
          placeholder="Country"
          className="input w-full"
        />

        <input
          name="needs_description"
          value={form.needs_description}
          onChange={handleChange}
          type="text"
          placeholder="Which best describes your needs?"
          className="input w-full mt-4"
        />

        <p className="text-xs text-gray-500 mt-4">
          By submitting your info in the form above, you agree to our <a href="#" className="text-blue-500 underline">Terms of Use</a> and
          <a href="#" className="text-blue-500 underline"> Privacy Notice</a>. We may use this info to contact you and/or use data from third parties to personalize your experience.
        </p>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 mt-4 rounded-md hover:bg-blue-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default LeadForm;
